import { API_DOMAIN, API_SCOPE_DOMAIN } from "./config";

export const msalConfig = {
  auth: {
    clientId: "093558b5-db8b-4ff0-bc33-f4f38abf9b96", // from Azure portal
    authority: "https://login.microsoftonline.com/8467b148-ffc4-40fe-a561-28e55d0f5a71", // or common/multitenant
    redirectUri:  process.env.REACT_APP_REDIRECT_URI || "https://app.minnkotadr.com", //"https://10.203.5.20:8443" //"http://localhost:3000", // or your deployed URL
  },
  cache: {
    cacheLocation: "localStorage", // or "sessionStorage"
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["openid", "profile", "email", `${API_SCOPE_DOMAIN}/Data.Read`] //["User.Read"], // or your API scopes
};
/*export const loginRequest = {
  scopes: ["api://25dc2cac-5e76-4dd0-94ac-c3757257212c/Data.Read"] //["User.Read"], // or your API scopes
};*/
export const tokenRequest = {
  scopes: ["User.Read", "https://api.minnkotadr.com/demandresponse/user.read"], // or your API scopes
};

/*export const protectedResources = {
  adminUserProfile: {
    endpoint: `${API_DOMAIN}/api/AdminUserProfile`,
    updateEndpoint: `${API_DOMAIN}/api/AdminUserProfile/{id}`,
    scopes: ["AdminUserProfile.Read", "AdminUserProfile.Write"],
  },
  plans: {
    //listEndpoint: `${API_DOMAIN}/api/Plan/list`,
    createEndpoint: `${API_DOMAIN}/api/Plan`,
    updateEndpoint: `${API_DOMAIN}/api/Plan/{id}`,
    scopes: ["Plans.Read", "Plans.Write"],
  },
  ripple: {
    //lastEndpoint: `${API_DOMAIN}/api/Ripple/last`,
    //listEndpoint: `${API_DOMAIN}/api/Ripple/list`,
    //statusEndpoint: `${API_DOMAIN}/api/Ripple/status`,
    submitEndpoint: `${API_DOMAIN}/api/Ripple/submit`,
    scopes: ["Ripple.Read", "Ripple.Write"],
  },
  schedule: {
    //listEndpoint: `${API_DOMAIN}/api/Schedule/list`,
    createEndpoint: `${API_DOMAIN}/api/Schedule/schedules`,
    upsertEndpoint: `${API_DOMAIN}/api/Schedule`,
    scopes: ["Schedule.Read", "Schedule.Write"],
  },
  seasonalSetting: {
    getEndpoint: `${API_DOMAIN}/api/SeasonalSetting`,
    upsertEndpoint: `${API_DOMAIN}/api/SeasonalSetting`,
    scopes: ["SeasonalSetting.Read", "SeasonalSetting.Write"],
  },
  systemCondition: {
    //getEndpoint: `${API_DOMAIN}/api/SystemCondition`,
    updateEndpoint: `${API_DOMAIN}/api/SystemCondition/{id}`,
    scopes: ["SystemCondition.Read", "SystemCondition.Write"],
  },
  user: {
    listEndpoint: `${API_DOMAIN}/api/User/list`,
    submitEndpoint: `${API_DOMAIN}/api/User/submit`,
    updateEndpoint: `${API_DOMAIN}/api/User/{id}`,
    scopes: ["User.Read", "User.Write"],
  },
  userNote: {
    endpoint: `${API_DOMAIN}/api/UserNote/{id}`,
    scopes: ["User.Read", "User.Write"],
  },
  userNotificationPreference: {
    oldEndpoint: `${API_DOMAIN}/api/UserNotificationPreference/old/{id}`,
    upsertOldEndpoint: `${API_DOMAIN}/api/UserNotificationPreference/old`,
    currentEndpoint: `${API_DOMAIN}/api/UserNotificationPreference/{id}`,
    upsertCurrentEndpoint: `${API_DOMAIN}/api/UserNotificationPreference/{id}`,
    scopes: ["User.Read", "User.Write"],
  }
};*/

/*export const openResources = {
  plans: {
    listEndpoint: `${API_DOMAIN}/api/Plan/list`,
    scopes: ["Plans.Read"]
  },
  ripple: {
    lastEndpoint: `${API_DOMAIN}/api/Ripple/last`,
    listEndpoint: `${API_DOMAIN}/api/Ripple/list`,
    statusEndpoint: `${API_DOMAIN}/api/Ripple/status`,
    scopes: ["Ripple.Read"]
  },
  schedule: {
    listEndpoint: `${API_DOMAIN}/api/Schedule/list`,
    scopes: ["Schedule.Read"],
  },
  status: {
    endpoint: `${API_DOMAIN}/api/Status/list`,
    scopes: ["Status.Read"],
  },
  systemCondition: {
    getEndpoint: `${API_DOMAIN}/api/SystemCondition`,
    weekWindowEndpoint: `${API_DOMAIN}/api/SystemCondition/weekwindow`,
    scopes: ["SystemCondition.Read"],
  },
  ripplePlans: {
    endpoint: `${API_DOMAIN}/demandresponse/ripple/plans`,
    scopes: ["Plans.Read"],
  },
  currentSchedule: {
    endpoint: `${API_DOMAIN}/demandresponse/loadmanagement/currentschedule`,
    scopes: ["Schedule.Read"],
  }
};*/

export const openResources = {
  plans: {
    listEndpoint: `${API_DOMAIN}/api/Plan/list`,
    //scopes: [`${API_SCOPE_DOMAIN}/Plans.Read`]
  },
  coop: {
    endPoint: `${API_DOMAIN}/api/Coop/{id}`,
    listEndPoint: `${API_DOMAIN}/api/Coop/list`,
    //scopes: [] //`User.Read`
  },
  ripple: {
    lastEndpoint: `${API_DOMAIN}/api/Ripple/last`,
    listEndpoint: `${API_DOMAIN}/api/Ripple/list`,
    lastOnOffEndpoint: `${API_DOMAIN}/api/Ripple/lastonoff`,
    statusEndpoint: `${API_DOMAIN}/api/Ripple/status`,
    //scopes: [`${API_SCOPE_DOMAIN}/Ripple.Read`]
  },
  schedule: {
    listEndpoint: `${API_DOMAIN}/api/Schedule/list`,
    //scopes: [`${API_SCOPE_DOMAIN}/Schedule.Read`],
  },
  status: {
    endpoint: `${API_DOMAIN}/api/Status/list`,
    //scopes: [`${API_SCOPE_DOMAIN}/Status.Read`],
  },
  systemCondition: {
    getEndpoint: `${API_DOMAIN}/api/SystemCondition`,
    weekWindowEndpoint: `${API_DOMAIN}/api/SystemCondition/weekwindow`,
    //scopes: [`${API_SCOPE_DOMAIN}/SystemCondition.Read`],
  },
  ripplePlans: {
    endpoint: `${API_DOMAIN}/api/Plan/list`,
    ///scopes: [`${API_SCOPE_DOMAIN}/Plans.Read`],
  },
  currentSchedule: {
    endpoint: `${API_DOMAIN}/api/Schedule/list`,
    //endpoint: `${API_DOMAIN}/demandresponse/loadmanagement/currentschedule`,
    //scopes: [`${API_SCOPE_DOMAIN}/Schedule.Read`],
  }
};